import React from "react";
import * as S from "./styles";

const AccountSectionLine = ({ children, bottomLine }) => {
  return <S.Wrapper bottomLine={bottomLine}>{children}</S.Wrapper>;
};

export default AccountSectionLine;
